import { Dictionary } from '@ngrx/entity';
import { createFeatureSelector, createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { SharedApplicationState } from '../shared-state';
import { OverviewOptions, OverviewOptionsState } from './overview-options.entity';
import { viewOptionsAdapter } from './overview-options.reducer';

export const getViewOptionsState: MemoizedSelector<
    object,
    OverviewOptionsState,
    DefaultProjectorFn<OverviewOptionsState>
> = createFeatureSelector<OverviewOptionsState>('overviewOptions');

const { selectEntities } = viewOptionsAdapter.getSelectors(getViewOptionsState);

export const selectFeature: (state: SharedApplicationState) => OverviewOptionsState = (state: SharedApplicationState) =>
    state.overviewOptions;

export function getOverviewOptions(
    id: string
): MemoizedSelector<object, OverviewOptions | undefined, DefaultProjectorFn<OverviewOptions | undefined>> {
    return createSelector(selectEntities, (entries: Dictionary<OverviewOptions>) => entries[id]);
}

export const overviewOptionsSelector: MemoizedSelector<
    object,
    Dictionary<OverviewOptions>,
    DefaultProjectorFn<Dictionary<OverviewOptions>>
> = createSelector(selectEntities, (entries: Dictionary<OverviewOptions>) => entries);
